"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lecce": {
    "41da3073": [{
      "hkey": "88430462",
      "slug": "villa-convento-zona-industriale",
      "name": "Villa Convento-Zona Industriale",
      "primary": true,
      "skipSearch": false
    }],
    "lecce-periferia": [{
      "hkey": "88430462",
      "slug": "villa-convento-zona-industriale",
      "name": "Villa Convento-Zona Industriale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1fa79512": [{
      "hkey": "a0e8fc80",
      "slug": "casermette-rudiae-aria-sana",
      "name": "Casermette-Rudiae-Aria Sana",
      "primary": true,
      "skipSearch": false
    }],
    "rudiae-aria-sana-poligono": [{
      "hkey": "a0e8fc80",
      "slug": "casermette-rudiae-aria-sana",
      "name": "Casermette-Rudiae-Aria Sana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a04eb888": [{
      "hkey": "0f6ca9a3",
      "slug": "borgo-pace-san-pio-universita",
      "name": "Borgo Pace-San Pio-Università",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-pace-universita-via-taranto": [{
      "hkey": "0f6ca9a3",
      "slug": "borgo-pace-san-pio-universita",
      "name": "Borgo Pace-San Pio-Università",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e93e06e0": [{
      "hkey": "fd0e71d9",
      "slug": "leuca",
      "name": "Leuca",
      "primary": true,
      "skipSearch": false
    }],
    "cicolella-via-puglia": [{
      "hkey": "fd0e71d9",
      "slug": "leuca",
      "name": "Leuca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lecce"
    }],
    "aa6403ed": [{
      "hkey": "225a9f3b",
      "slug": "borgo-piave-frigole",
      "name": "Borgo Piave-Frigole",
      "primary": true,
      "skipSearch": false
    }],
    "frigole-borgo-piave-san-ligorio": [{
      "hkey": "225a9f3b",
      "slug": "borgo-piave-frigole",
      "name": "Borgo Piave-Frigole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2af1b5b4": [{
      "hkey": "b501b895",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "lecce-centro": [{
      "hkey": "b501b895",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "40e4c10c": [{
      "hkey": "6eee511a",
      "slug": "merine-partigiani-salesiani-stadio",
      "name": "Merine-Partigiani-Salesiani-Stadio",
      "primary": true,
      "skipSearch": false
    }],
    "salesiani-partigiani-calio-pranzo": [{
      "hkey": "6eee511a",
      "slug": "merine-partigiani-salesiani-stadio",
      "name": "Merine-Partigiani-Salesiani-Stadio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "dbb3883f": [{
      "hkey": "a8db5364",
      "slug": "san-cataldo",
      "name": "San Cataldo",
      "primary": true,
      "skipSearch": false
    }],
    "san-cataldo-villaggi": [{
      "hkey": "a8db5364",
      "slug": "san-cataldo",
      "name": "San Cataldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c36e6fe0": [{
      "hkey": "2d1a8a59",
      "slug": "stazione",
      "name": "Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "san-pio-rudiae-idria-ferrovia": [{
      "hkey": "2d1a8a59",
      "slug": "stazione",
      "name": "Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0439f605": [{
      "hkey": "6eee511a",
      "slug": "merine-partigiani-salesiani-stadio",
      "name": "Merine-Partigiani-Salesiani-Stadio",
      "primary": true,
      "skipSearch": false
    }],
    "stadio": [{
      "hkey": "6eee511a",
      "slug": "merine-partigiani-salesiani-stadio",
      "name": "Merine-Partigiani-Salesiani-Stadio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lecce"
    }],
    "32bbbab9": [{
      "hkey": "061623e3",
      "slug": "torre-rinalda",
      "name": "Torre Rinalda",
      "primary": true,
      "skipSearch": false
    }],
    "torre-rinalda-torre-specchiolla": [{
      "hkey": "061623e3",
      "slug": "torre-rinalda",
      "name": "Torre Rinalda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4063a7e6": [{
      "hkey": "6eee511a",
      "slug": "merine-partigiani-salesiani-stadio",
      "name": "Merine-Partigiani-Salesiani-Stadio",
      "primary": true,
      "skipSearch": false
    }],
    "via-merine-partigiani-fondone": [{
      "hkey": "6eee511a",
      "slug": "merine-partigiani-salesiani-stadio",
      "name": "Merine-Partigiani-Salesiani-Stadio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lecce"
    }],
    "0738a678": [{
      "hkey": "a0e8fc80",
      "slug": "casermette-rudiae-aria-sana",
      "name": "Casermette-Rudiae-Aria Sana",
      "primary": true,
      "skipSearch": false
    }],
    "via-san-cesario-poligono": [{
      "hkey": "a0e8fc80",
      "slug": "casermette-rudiae-aria-sana",
      "name": "Casermette-Rudiae-Aria Sana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;